import { render, staticRenderFns } from "./DirectorShifts.vue?vue&type=template&id=f2bfa012&lang=pug&"
import script from "./DirectorShifts.vue?vue&type=script&lang=js&"
export * from "./DirectorShifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports